package team.platforma.aicombo.activity.main

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.cross_m
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BottomSheetScaffold
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SheetValue
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.material3.rememberBottomSheetScaffoldState
import androidx.compose.material3.rememberStandardBottomSheetState
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import system_component_style.SystemStyle
import team.platforma.aicombo.activity.main.component.generation.GenerationComponent
import team.platforma.aicombo.activity.main.component.library.LibraryComponent
import team.platforma.aicombo.activity.main.component.main.MainComponent
import team.platforma.aicombo.activity.main.component.profile.ProfileComponent
import team.platforma.aicombo.activity.main.component.settings.SettingsComponent
import team.platforma.aicombo.network.Network
import team.platforma.aicombo.network.NetworkItem
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.dictionary_presentation.DictionaryViewModel
import team.platforma.extra_nav.component.activity_component.Activity
import team.platforma.extra_nav.component.activity_component.ActivityScaffold
import team.platforma.extra_nav.ui.SimpleBottomNavigationBar
import team.platforma.extra_nav.ui.SimpleNavigationRail
import team.platforma.extra_nav.utils.Type
import team.platforma.extra_nav.utils.UI
import team.platforma.extra_nav.utils.navButtonController
import team.platforma.extra_nav.utils.rememberDeviceType
import team.platforma.extra_nav.utils.rememberUiOrientation
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.button.AppTextButton
import team.platforma.multiplatform_material_extension.toolbar.Toolbar
import team.platforma.multiplatform_material_extension.ui.theme.ThemeSwitcher

@OptIn(ExperimentalMaterial3Api::class, KoinExperimentalAPI::class)
object MainApp : Activity(
    route = "main_app",
    components = listOf(
        MainComponent,
        ProfileComponent,
        GenerationComponent,
        LibraryComponent,
        SettingsComponent
    ),
    activityScaffold = { components ->

        val dictionaryViewModel = koinViewModel<DictionaryViewModel>()
//        dictionaryViewModel.loadAiChapter()
        LaunchedEffect(Unit) {
            dictionaryViewModel.loadAiModels()
        }



        val aiChapterList by dictionaryViewModel.aiChapterList.collectAsState()
        val aiList by dictionaryViewModel.observeAllAiModels()
            .collectAsState(initial = emptyList())
        val aiMap = aiList.groupBy { it.chapter }
        var aiChapter by remember { mutableStateOf(0L) }
        val list by if (aiChapter == 0L) {
            dictionaryViewModel.observeAllAiModels()
                .collectAsState(initial = emptyList())
        } else {

            dictionaryViewModel.observeAiModelsByChapter(aiChapter)
                .collectAsState(initial = emptyList())
        }



        val orientation by rememberUiOrientation()
        val type by rememberDeviceType()




        val controller = navButtonController()
        val checked by controller.observeState(GenerationComponent.route)

        val scaffoldState = rememberBottomSheetScaffoldState(
            bottomSheetState = rememberStandardBottomSheetState(
                initialValue = SheetValue.Hidden,
                skipHiddenState = false
            )
        )
        LaunchedEffect(checked) {
            if (checked) {
                scaffoldState.bottomSheetState.show()
            } else {
                scaffoldState.bottomSheetState.hide()
            }
        }

        LaunchedEffect(scaffoldState.bottomSheetState) {
            snapshotFlow { scaffoldState.bottomSheetState.currentValue }
                .collect { sheetValue ->
                    if (sheetValue == SheetValue.Hidden && checked) {
                        controller.state(GenerationComponent.route, false)
                    }
                }
        }

        ActivityScaffold(
            components = components,
            bottomBar = { componentNavigator ->
                SimpleBottomNavigationBar(components, componentNavigator)
            },
            navRail = { componentNavigator ->
                SimpleNavigationRail(
                    components,
                    componentNavigator,
                    when (type) {
                        Type.MOBILE -> true
                        Type.TABLET -> false
                        Type.DESKTOP -> false
                    },
                    areaModifier = Modifier.background(AppColors.bg.default().default)
                )
            },
            topBar = { componentNavigator ->
                SystemStyle().statusBarColor(AppColors.bg.base().default)
                Toolbar(
                    title = {
                        Text("Aicombo")
                    },
                    actions = {
                        ThemeSwitcher()
                    }
                )

            },
            bottomSheetLayer = { componentNavigator, maxWidth, maxHeight ->
                when (type) {
                    Type.MOBILE -> {
                        when (orientation) {
                            UI.PORTRAIT -> {
                                BottomSheetScaffold(
                                    scaffoldState = scaffoldState,
                                    sheetContent = {

                                        LazyVerticalGrid(
                                            columns = GridCells.Fixed(3),
                                            modifier = Modifier.fillMaxSize(),
                                            contentPadding = PaddingValues(horizontal = 16.dp),
                                            verticalArrangement = Arrangement.spacedBy(8.dp),
                                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                                        ) {
                                            aiMap.forEach { (key, items) ->
                                                item(span = { GridItemSpan(maxLineSpan) }) {
                                                    Text(
                                                        text = aiChapterList.find { it.id == key }?.name
                                                            ?: "",
                                                        style = Typography.textLg(FontWeights.Medium),
                                                        modifier = Modifier
                                                            .fillMaxWidth()
                                                            .clip(RoundedCornerShape(6.dp))
                                                            .background(AppColors.bg.default().default)
                                                            .padding(
                                                                horizontal = 16.dp,
                                                                vertical = 8.dp
                                                            )
                                                    )
                                                }

                                                // Элементы сетки 3 в ряд
                                                items(items) { item ->
                                                    Box(
                                                        modifier = Modifier.fillMaxWidth()
                                                            .border(1.dp,
                                                                AppColors.border().default,
                                                                RoundedCornerShape(6.dp)
                                                            )
                                                            .clip(
                                                                RoundedCornerShape(6.dp)
                                                            )
                                                            .background(AppColors.bg.base().default)
                                                            .clickable(
                                                                enabled = true
                                                            ) {

                                                            }
                                                    ) {
                                                        Column(
                                                            modifier = Modifier.fillMaxSize()
                                                                .padding(16.dp),
                                                            horizontalAlignment = Alignment.CenterHorizontally
                                                        ) {
                                                            Box(
                                                                modifier = Modifier.size(46.dp)
                                                                    .clip(RoundedCornerShape(100))
                                                                    .background(Color.LightGray)
                                                            )

                                                            Spacer(
                                                                modifier = Modifier.height(8.dp)
                                                            )
                                                            Text(
                                                                text = item.name,
                                                                color = AppColors.text().default,
                                                                style = Typography.textSm(FontWeights.Regular),
                                                                maxLines = 2,
                                                                overflow = TextOverflow.Ellipsis,
                                                                modifier = Modifier.fillMaxWidth(),
                                                                textAlign = TextAlign.Center,
                                                                minLines = 2
                                                            )
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                    },
                                    contentColor = Color.Transparent,
                                    sheetPeekHeight = maxHeight / 2,
                                    sheetContainerColor = AppColors.bg.base().default,
                                    sheetShadowElevation = 4.dp

                                ) {}
                            }

                            else -> {}
                        }
                    }

                    else -> {}
                }
            },
            modalLayer = if (checked) {
                when (type) {
                    Type.MOBILE -> {
                        when (orientation) {
                            UI.LANDSCAPE -> {
                                {
                                    Card(
                                        modifier = Modifier.heightIn(max = 400.dp)
                                            .widthIn(max = 1000.dp)
                                            .padding(16.dp)
                                            .align(Alignment.Center),
                                        colors = CardDefaults.cardColors()
                                            .copy(containerColor = AppColors.bg.base().default)
                                    ) {

//                                        val aiChapterList by dictionaryViewModel.aiChapterList.collectAsState()
//                                        var aiChapter by remember { mutableStateOf(0L) }
//
//
//                                        val list by if (aiChapter == 0L) {
//                                            dictionaryViewModel.observeAllAiModels()
//                                                .collectAsState(initial = emptyList())
//                                        } else {
//
//                                            dictionaryViewModel.observeAiModelsByChapter(aiChapter)
//                                                .collectAsState(initial = emptyList())
//                                        }

                                        Row(
                                            modifier = Modifier.padding(16.dp).fillMaxSize()
                                        ) {
                                            LazyColumn(
                                                modifier = Modifier.width(150.dp)
                                            ) {

                                                itemsIndexed(aiChapterList) { index, item ->
                                                    AppFilledButton(
                                                        onClick = {
                                                            aiChapter = index.toLong()
                                                        },
                                                        colors = ButtonDefaults.buttonColors().copy(
                                                            containerColor = if (aiChapter.toInt() == index) AppColors.bg.primary().default else AppColors.bg.base().default,
                                                            contentColor = if (aiChapter.toInt() == index) AppColors.text().light else AppColors.text().default
                                                        ),
                                                        modifier = Modifier.fillMaxWidth()
                                                    ) {
                                                        Text(
                                                            text = item.name,
                                                            style = Typography.textLg(FontWeights.Regular),
                                                            textAlign = TextAlign.Start,
                                                            modifier = Modifier.fillMaxWidth()
                                                        )
                                                    }
                                                }

                                            }

                                            VerticalDivider(
                                                modifier = Modifier.fillMaxHeight().width(1.dp).padding(start = 16.dp),
                                                color = AppColors.border().default
                                            )

                                            LazyVerticalGrid(
                                                columns = GridCells.Fixed(3),
                                                modifier = Modifier.padding(start = 40.dp).weight(1f).fillMaxHeight(),
                                                verticalArrangement = Arrangement.spacedBy(8.dp),
                                                horizontalArrangement = Arrangement.spacedBy(8.dp)

                                            ) {

                                                items(list) { item ->
                                                    Box(
                                                        modifier = Modifier.fillMaxWidth()
                                                            .border(
                                                                1.dp,
                                                                AppColors.border().default,
                                                                RoundedCornerShape(6.dp)
                                                            )
                                                            .clip(
                                                                RoundedCornerShape(6.dp)
                                                            )
                                                            .background(AppColors.bg.base().default)
                                                            .clickable(
                                                                enabled = true
                                                            ) {

                                                            }
                                                    ) {
                                                        Column(
                                                            modifier = Modifier.fillMaxSize()
                                                                .padding(16.dp),
                                                            horizontalAlignment = Alignment.CenterHorizontally
                                                        ) {
                                                            Box(
                                                                modifier = Modifier.size(46.dp)
                                                                    .clip(RoundedCornerShape(100))
                                                                    .background(Color.LightGray)
                                                            )

                                                            Text(
                                                                text = item.name,
                                                                color = AppColors.text().default,
                                                                style = Typography.text2xl(
                                                                    FontWeights.Medium
                                                                ),
                                                                maxLines = 1,
                                                                overflow = TextOverflow.Ellipsis
                                                            )


                                                        }
                                                    }
                                                }
                                            }

                                        }

                                    }
                                }
                            }

                            UI.PORTRAIT -> null
                        }
                    }

                    Type.TABLET -> {
                        {
                            Card(
                                modifier = Modifier.heightIn(max = 600.dp)
                                    .widthIn(max = 1000.dp)
                                    .padding(24.dp)
                                    .align(Alignment.Center),
                                colors = CardDefaults.cardColors()
                                    .copy(containerColor = AppColors.bg.base().default)
                            ) {

//                                val aiChapterList by dictionaryViewModel.aiChapterList.collectAsState()
//                                var aiChapter by remember { mutableStateOf(0L) }
//
//
//                                val list by if (aiChapter == 0L) {
//                                    dictionaryViewModel.observeAllAiModels()
//                                        .collectAsState(initial = emptyList())
//                                } else {
//
//                                    dictionaryViewModel.observeAiModelsByChapter(aiChapter)
//                                        .collectAsState(initial = emptyList())
//                                }

                                Column {
                                    Box(
                                        modifier = Modifier.fillMaxWidth(),
                                        contentAlignment = Alignment.CenterEnd
                                    ) {
                                        IconButton(
                                            onClick = {
                                                controller.state(GenerationComponent.route, false)
                                            }
                                        ){
                                            Icon(
                                                painter = painterResource(Res.drawable.cross_m),
                                                contentDescription = null,
                                                tint = AppColors.text().default
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.padding(16.dp)
                                    ) {
                                        LazyColumn(
                                            modifier = Modifier.width(150.dp),

                                        ) {

                                            itemsIndexed(aiChapterList) { index, item ->
                                                AppFilledButton(
                                                    onClick = {
                                                        aiChapter = index.toLong()
                                                    },
                                                    colors = ButtonDefaults.buttonColors().copy(
                                                        containerColor = if (aiChapter.toInt() == index) AppColors.bg.primary().default else AppColors.bg.base().default,
                                                        contentColor = if (aiChapter.toInt() == index) AppColors.text().light else AppColors.text().default
                                                    ),
                                                    modifier = Modifier.fillMaxWidth()
                                                ) {
                                                    Text(
                                                        text = item.name,
                                                        style = Typography.textLg(FontWeights.Regular),
                                                        textAlign = TextAlign.Start,
                                                        modifier = Modifier.fillMaxWidth()
                                                    )
                                                }
                                            }

                                        }

                                        VerticalDivider(
                                            modifier = Modifier.width(1.dp).padding(start = 16.dp),
                                            color = AppColors.border().default
                                        )

                                        LazyVerticalGrid(
                                            columns = GridCells.Fixed(3),
                                            modifier = Modifier.padding(start = 40.dp).weight(1f),
                                            verticalArrangement = Arrangement.spacedBy(8.dp),
                                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                                            ) {

                                            items(list) { item ->
                                                Box(
                                                    modifier = Modifier.fillMaxWidth()
                                                        .border(
                                                            1.dp,
                                                            AppColors.border().default,
                                                            RoundedCornerShape(6.dp)
                                                        )
                                                        .clip(
                                                            RoundedCornerShape(6.dp)
                                                        )
                                                        .background(AppColors.bg.base().default)
                                                        .clickable(
                                                            enabled = true
                                                        ) {

                                                        }
                                                ) {
                                                    Column(
                                                        modifier = Modifier.fillMaxSize()
                                                            .padding(16.dp),
                                                        horizontalAlignment = Alignment.CenterHorizontally
                                                    ) {
                                                        Box(
                                                            modifier = Modifier.size(46.dp)
                                                                .clip(RoundedCornerShape(100))
                                                                .background(Color.LightGray)
                                                        )

                                                        Text(
                                                            text = item.name,
                                                            color = AppColors.text().default,
                                                            style = Typography.text2xl(
                                                                FontWeights.Medium
                                                            ),
                                                            maxLines = 1,
                                                            overflow = TextOverflow.Ellipsis
                                                        )


                                                    }
                                                }
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }

                    Type.DESKTOP -> {
                        {
                            Card(
                                modifier = Modifier.heightIn(max = 600.dp)
                                    .widthIn(max = 1000.dp)
                                    .padding(24.dp)
                                    .align(Alignment.Center),
                                colors = CardDefaults.cardColors()
                                    .copy(containerColor = AppColors.bg.base().default)
                            ) {

//                                val aiChapterList by dictionaryViewModel.aiChapterList.collectAsState()
//
//
//
//                                val list by if (aiChapter == 0L) {
//                                    dictionaryViewModel.observeAllAiModels()
//                                        .collectAsState(initial = emptyList())
//                                } else {
//
//                                    dictionaryViewModel.observeAiModelsByChapter(aiChapter)
//                                        .collectAsState(initial = emptyList())
//                                }

                                Column {
                                    Box(
                                        modifier = Modifier.fillMaxWidth(),
                                        contentAlignment = Alignment.CenterEnd
                                    ) {
                                        IconButton(
                                            onClick = {
                                                controller.state(GenerationComponent.route, false)
                                            }
                                        ){
                                            Icon(
                                                painter = painterResource(Res.drawable.cross_m),
                                                contentDescription = null,
                                                tint = AppColors.text().default
                                            )
                                        }
                                    }
                                    Row(
                                        modifier = Modifier.padding(16.dp)
                                    ) {
                                        LazyColumn(
                                            modifier = Modifier.width(150.dp)
                                        ) {

                                            itemsIndexed(aiChapterList) { index, item ->
                                                AppFilledButton(
                                                    onClick = {
                                                        aiChapter = index.toLong()
                                                    },
                                                    colors = ButtonDefaults.buttonColors().copy(
                                                        containerColor = if (aiChapter.toInt() == index) AppColors.bg.primary().default else AppColors.bg.base().default,
                                                        contentColor = if (aiChapter.toInt() == index) AppColors.text().light else AppColors.text().default
                                                    ),
                                                    modifier = Modifier.fillMaxWidth()
                                                ) {
                                                    Text(
                                                        text = item.name,
                                                        style = Typography.textLg(FontWeights.Regular),
                                                        textAlign = TextAlign.Start,
                                                        modifier = Modifier.fillMaxWidth()
                                                    )
                                                }
                                            }

                                        }

                                        VerticalDivider(
                                            modifier = Modifier.width(1.dp).padding(start = 16.dp),
                                            color = AppColors.border().default
                                        )

                                        LazyVerticalGrid(
                                            columns = GridCells.Fixed(3),
                                            modifier = Modifier.padding(start = 40.dp).weight(1f),
                                            verticalArrangement = Arrangement.spacedBy(8.dp),
                                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                                            ) {

                                            items(list) { item ->
                                                Box(
                                                    modifier = Modifier.fillMaxWidth()
                                                        .border(
                                                            1.dp,
                                                            AppColors.border().default,
                                                            RoundedCornerShape(6.dp)
                                                        )
                                                        .clip(
                                                            RoundedCornerShape(6.dp)
                                                        )
                                                        .background(AppColors.bg.base().default)
                                                        .clickable(
                                                            enabled = true
                                                        ) {

                                                        }
                                                ) {
                                                    Column(
                                                        modifier = Modifier.fillMaxSize()
                                                            .padding(16.dp),
                                                        horizontalAlignment = Alignment.CenterHorizontally
                                                    ) {
                                                        Box(
                                                            modifier = Modifier.size(46.dp)
                                                                .clip(RoundedCornerShape(100))
                                                                .background(Color.LightGray)
                                                        )

                                                        Text(
                                                            text = item.name,
                                                            color = AppColors.text().default,
                                                            style = Typography.text2xl(
                                                                FontWeights.Medium
                                                            ),
                                                            maxLines = 1,
                                                            overflow = TextOverflow.Ellipsis
                                                        )


                                                    }
                                                }
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
            } else null,
            showNavRail = when (orientation) {
                UI.LANDSCAPE -> true
                UI.PORTRAIT -> false
            }
        )
    }
)